import { FieldCheckBox } from '@components/field-builder/field-checkbox';
import FormI9AddressFieldItems from '@containers/form-i9/address-field-items';
import {
    BorderedGrid,
    BorderedGridItem,
    ReadonlyFieldLabel,
    ReadonlyFieldValue,
    SectionBox,
    SectionSubHeading
} from '@containers/form-i9/styles';
import { Grid } from '@material-ui/core';
import { FieldType } from '@models/field-builder/field-type';
import { ISection1PreparerTranslator } from '@models/onboarding-review/section1-preparer-translator';
import { Title } from '@screens/review-section3/review/styles';
import { createTranslationService } from '@services/factories';
import { cacheTranslations } from '@utils/cache-translations';
import { observer } from 'mobx-react';
import * as React from 'react';

interface IProps {
    fields: ISection1PreparerTranslator;
}

enum FormI9PreparerTranslatorCertificationTranslation {
    sectionSubheading = 'sectionSubheading',
    didNotUsePreparerTranslator = 'didNotUsePreparerTranslator',
    didUsePreparerTranslator = 'didUsePreparerTranslator',
    sectionSubtitle = 'sectionSubtitle',
    assistedCompletionAttestation = 'assistedCompletionAttestation',
    preparerTranslatorSignatureLabel = 'preparerTranslatorSignatureLabel',
    todaysDateLabel = 'todaysDateLabel',
    lastNameLabel = 'lastNameLabel',
    firstNameLabel = 'firstNameLabel'
}

const FormI9PreparerTranslatorCertification: React.FunctionComponent<IProps> = ({ fields }) => {
    const translations = cacheTranslations(
        createTranslationService(),
        FormI9PreparerTranslatorCertificationTranslation,
        'preparerTranslatorCertification'
    );

    return (
        <div>
            <SectionBox>
                <SectionSubHeading>{translations.sectionSubheading}</SectionSubHeading>
                <Grid container={true}
                      justifyContent={'flex-start'}
                      wrap='wrap'>
                    <Grid item={true} xs={12} sm={true}>
                        <FieldCheckBox type={FieldType.CHECKBOX}
                                       id={'did-not-use-translator-preparer'}
                                       label={translations.didNotUsePreparerTranslator}
                                       value={!fields.didUseTranslatorPreparer}
                                       disabled={true}/>
                    </Grid>
                    <Grid item={true} xs={12} sm={true}>
                        <FieldCheckBox type={FieldType.CHECKBOX}
                                       id={'did-use-translator-preparer'}
                                       label={translations.didUsePreparerTranslator}
                                       value={fields.didUseTranslatorPreparer}
                                       disabled={true}/>
                    </Grid>
                </Grid>
                <i>{translations.sectionSubtitle}</i>
            </SectionBox>
            <Title>{translations.assistedCompletionAttestation}</Title>
            <BorderedGrid container={true}
                          wrap='wrap'>
                {/* Row 1 */}
                <BorderedGridItem xs={12} sm={9}>
                    <ReadonlyFieldLabel>
                        {translations.preparerTranslatorSignatureLabel}
                    </ReadonlyFieldLabel>
                    <ReadonlyFieldValue>
                        {fields.signature}
                    </ReadonlyFieldValue>
                </BorderedGridItem>
                <BorderedGridItem xs={12} sm={3}>
                    <ReadonlyFieldLabel>
                        {translations.todaysDateLabel}
                    </ReadonlyFieldLabel>
                    <ReadonlyFieldValue>
                        {fields.signedOn}
                    </ReadonlyFieldValue>
                </BorderedGridItem>
                {/* Row 2 */}
                <BorderedGridItem xs={6} sm={6}>
                    <ReadonlyFieldLabel>
                        {translations.lastNameLabel}
                    </ReadonlyFieldLabel>
                    <ReadonlyFieldValue>
                        {fields.lastName}
                    </ReadonlyFieldValue>
                </BorderedGridItem>
                <BorderedGridItem xs={6} sm={6}>
                    <ReadonlyFieldLabel>
                        {translations.firstNameLabel}
                    </ReadonlyFieldLabel>
                    <ReadonlyFieldValue>
                        {fields.firstName}
                    </ReadonlyFieldValue>
                </BorderedGridItem>
                {/* Row 3 */}
                <FormI9AddressFieldItems fields={fields}/>
            </BorderedGrid>
        </div>
    );
};

export default observer(FormI9PreparerTranslatorCertification);



// WEBPACK FOOTER //
// ./src/containers/form-i9/preparer-translator-certification.tsx